export enum Country {
  IT = 'IT',
  ES = 'ES',
  TR = 'TR'
}
